<template>
  <div class="mb-1">
    <div style="border: 1px solid gainsboro; border-radius: 15px; padding: 0 1rem 0 1rem;">
      <b-row class="mt-1">
        <b-form-group
          label="Tipo"
          class="col-2"
        >
          <b-input
            v-model="value.tipoCertificado"
            :disabled="disabledInputs"
          />
        </b-form-group>
        <b-form-group
          label="Modelo"
          class="col-2"
        >
          <b-input
            v-model="value.modelo"
            :disabled="disabledInputs"
          />
        </b-form-group>
        <b-col cols="4">
          <b-form-group label="Senha">
            <senha-input
              ref="senhaCertificado"
              v-model="value.senha"
              :disabled="disabledInputs"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label="Data de Vencimento">
            <data-input
              v-model="value.dataDeVencimento"
              :disabled="disabledInputs"
              :vencido="validaVencido()"
            />
          </b-form-group>
        </b-col>
        <b-form-group
          label="Por Procuração"
          class="col-2"
        >
          <b-input
            v-model="value.porProcuracao"
            :disabled="disabledInputs"
          />
        </b-form-group>
      </b-row>
      <b-row
        class="mb-50 mt-50"
      >
        <b-col cols="2">
          <b-form-checkbox
            v-model="value.emProcesso"
            :disabled="disabledInputs"
            style="margin-right: 8rem;"
          >
            Em Processo
          </b-form-checkbox>
        </b-col>
        <b-col cols="2">
          <b-form-checkbox
            v-model="value.naoEnviarAlerta"
            :disabled="disabledInputs"
          >
            Dispensar Alerta de Vencimento
          </b-form-checkbox>
        </b-col>
        <b-col cols="5">
          <div v-if="value.dataAlteracaoDispensado">
            <span style="margin-right: 5px;">
              Dispensado por: {{ value.usuAlteracaoDispensado }}
            </span>
            <span>
              Data: {{ value.dataAlteracaoDispensado }}
            </span>
          </div>
        </b-col>
        <b-col cols="5">
          <div style="display: flex; align-items: end; flex-direction: column;">
            <div
              v-if="value.nome"
              class="text-certificado"
              @click="baixarArquivo"
            >
              Arquivo: {{ value.nome }}
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style>
.container-text-certificado {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: #ffff;
  margin-bottom: 1rem;
}
.text-certificado {
  border-radius: 5px;
  background: #c1af1d;
  color:#ffff;
  cursor: pointer;
  padding: 0 5px 0 5px;
  margin-bottom: 1rem;

  max-width: 50ch;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.remove-certificado {
  cursor: pointer;
  padding: 0 5px 0 5px;
}
</style>

<script>
/* eslint-disable */
import apiCertificado from '@/app-modulo/comuns/certificado/shared/services/api.js'
import { canDownloadECPF, canDownloadECnpj } from '@/auth/utils'
import moment from 'moment'
import ultis from '@/@core/utils/file-utils'

export default {
  name: 'DadosCertificado',
  components: {
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    modeloCertificado: {
      type: String,
      default: 'e-CNPJ',
    },
  },
  data() {
    return {
      now: new Date(),
      disabledInputs: true,
      certificado: {},
      fileName: '',
      valor: [],
      url: '',
      valueInner: {},
      arquivoExistente: null,
    }
  },
  
  
  methods: {
    arquivo(value) {
      if (value ) {
        const binary = atob(value)
        const array = []
        for (let i = 0; i < binary.length; i += 1) {
          array.push(binary.charCodeAt(i))
        }
        const file = new Blob([new Uint8Array(array)], { type: 'application/pfx' })
        this.arquivoExistente = file
        this.$refs.upload.add(file)
      }
    },
    baixarArquivo() {
      let downloadFeito = false
      if ((this.modeloCertificado === 'e-CNPJ' && canDownloadECnpj()) || (this.modeloCertificado === 'e-CPF' && canDownloadECPF())) {
        downloadFeito = true
        ultis.downloadCertificado(this.value.certificadoArquivo, this.value.nome)
      } else {
        downloadFeito = false
        this.$erro('Você não tem permissão para realizar o download! Contate o administrador do sistema.')
      }
      if(downloadFeito){
        this.AddHistoricos(this.value.id)
      }
    },
    validaVencido(){
      const dataString = moment().format('DD/MM/YYYY')
      const now = moment(dataString, 'DD/MM/YYYY').toDate()
      const data = moment(this.value.dataDeVencimento, 'DD/MM/YYYY').toDate()
      return data < now
    },
    AddHistoricos(id) {
      const tela = 'empresa'
      apiCertificado.addHistorico(id, tela)
        .then(() => {
        })
        .catch(err => {
          this.$erro(err)
        })
    },
    
  },
}
</script>
